import axios from "axios";
import { store } from "../Redux/store";
import { clearAuth, setrefreshToken } from "../Redux/Slice/authSlice";
const BASE_URL = process.env.REACT_APP_API_URL;

const baseService = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
});

const refreshTokenService = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
});

const logoutAndRedirect = () => {
  store.dispatch(clearAuth());
  window.location.href = "/signin"; 
};

refreshTokenService.interceptors.response.use(
  (response) => response,
  (error) => {
    logoutAndRedirect();
    return Promise.reject(error);
  }
);

baseService.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error;

    if (response && (response.status === 401 || response.status === 403)) {
      logoutAndRedirect();
      return Promise.reject(error);
    }

    if (response && response.status === 400) {
      const { auth } = store.getState();

      if (!auth.refreshToken) {
        logoutAndRedirect();
        return Promise.reject(new Error("No refresh token available"));
      }

      try {
        const refreshResponse = await refreshTokenService.get("/refreshToken", {
          headers: {
            "x-auth-token": auth.refreshToken,
          },
        });

        if (!refreshResponse?.data?.data?.token) {
          throw new Error("Invalid token received from refresh endpoint");
        }

        store.dispatch(setrefreshToken(refreshResponse.data.data));
        config.headers["x-auth-token"] = refreshResponse.data.data.token;
        localStorage.setItem("token", refreshResponse.data.data.token);
        config.baseURL = undefined;

        return baseService.request(config);
      } catch (refreshError) {
        logoutAndRedirect();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default baseService;